import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 发放相关接口
 */
const grant = {

      /**
       * 会员卡相关
       */
      cardList(page){
         return axios.post(ipAddress.qi+'/admin/a1/vip-grant-log/page',page,true)
      },

      //会员卡类型筛选
      getVipType(){
        return axios.post(ipAddress.qi+'/admin/a1/commons/getVipType',null,false)
      },
      //录入会员卡
      cardAdd(from){
        return axios.post(ipAddress.qi+'/admin/a1/staff-product/save',from,true)
      },
      //发放会员卡
      cardGrant(from){
        return axios.post(ipAddress.qi+'/admin/a1/staff-product/grant',from,true)
      },
      //回收会员卡
      cardRecycle(from){
        return axios.post(ipAddress.qi+'/admin/a1/staff-product/recycle',from,true)
      },
      //删除会员卡
      cardDelete(from){
        return axios.post(ipAddress.qi+'/admin/a1/staff-product/delByNum',from,true)
      },



      /**
       * 收据
       */
      //收据分页
      receiptList(page){
        return axios.post(ipAddress.qi+'/admin/a1/receipt-grant-log/page',page,true)
      },
      //录入收据
      receiptAdd(from){
        return axios.post(ipAddress.qi+'/admin/a1/receipt/save',from,true)
      },
      //发放会员卡
      receiptGrant(from){
        return axios.post(ipAddress.qi+'/admin/a1/receipt/grant',from,true)
      },
      //回收会员卡
      receiptRecycle(from){
        return axios.post(ipAddress.qi+'/admin/a1/receipt/recycle',from,true)
      },
      //删除会员卡
      receiptDelete(from){
        return axios.post(ipAddress.qi+'/admin/a1/receipt/delByNum',from,true)
      },

      /**
       * 礼品相关
       */
      //添加礼品
      addGitf(from){
        return axios.post(ipAddress.qi+'/admin/s1/gift/addGift',from,true)
      },
      //礼品分页
      giftList(page){
        return axios.post(ipAddress.qi+'/admin/s1/gift/giftPage',page,true)
      },
      //礼品修改
      giftUpdate(from){
        return axios.post(ipAddress.qi+'/admin/s1/gift/upById',from,true)
      },
      //礼品删除
      giftDelete(id){
        return axios.post(ipAddress.qi+'/admin/s1/gift/delById',QS.stringify({
            id:id
        }),false)
      },

      //产品相关
      //添加产品
      addProduct(from){
        return axios.post(ipAddress.qi+'/admin/s1/gift/addProduct',from,true)
      },
      //产品分页
      productList(page){
        return axios.post(ipAddress.qi+'/admin/s1/gift/productPage',page,true)
      },



}
export default grant;


// WEBPACK FOOTER //
// ./src/js/grant/grant.js